import Seo from "./Seo";
import { buildkalyanDescription, buildkalyanJsonLd, buildkalyanKeywords } from "../utils/kalyanSeo";

type kalyanSeoProps = {
  kalyan: any;
  canonicalPath: string;
};

const kalyanSeo = ({ kalyan, canonicalPath }: kalyanSeoProps) => {
    // debugger;
  if (!kalyan) return null;

  const title = kalyan?.pageTitle || kalyan?.ogTitle || (kalyan?.name ? `${kalyan.name} | Gita Seva` : "Gita Seva kalyan");
  const description = kalyan?.pageDescription || kalyan?.ogDescription || buildkalyanDescription(kalyan);
  const keywords = buildkalyanKeywords(kalyan);
  const image = kalyan?.ogImage || kalyan?.kalyanPath || "";
  const jsonLd = buildkalyanJsonLd(kalyan, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="kalyan"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default kalyanSeo;






